import { EventTracker } from '../EventTracker'
import * as Events from '../../events'

type GoogleEventParameters = Gtag.CustomParams | Gtag.ControlParams | Gtag.EventParams

export interface GoogleTrackerOptions {
  conversionId: string
}

export default class GoogleTracker extends EventTracker {
  public constructor() {
    super()

    if (!window.gtag) {
      throw new Error(
        'The Google Ads Pixel snippet is missing, but must be installed to use the GoogleTracker.'
      )
    }
  }

  public get gtag() {
    return window.gtag!
  }

  /**
   * A wrapper for the Google Ads tracking API (`gtag`).
   */
  private track(conversionLabel: string, parameters?: GoogleEventParameters) {
    this.gtag('event', 'conversion', {
      send_to: `AW-829395938/${conversionLabel}`,
      ...parameters,
    })
  }

  public trackLandingPageSubmitted() {
    this.track('oN5_COvA14cBEOKnvosD')
  }

  public trackLandingPageViewed() {
    this.track('XSQkCN3DncMBEOKnvosD')
  }

  public trackOrderCompleted({ properties }: Events.OrderCompletedEvent) {
    this.track('tKGeCNHs5YcBEOKnvosD', {
      value: parseFloat(properties.value),
      currency: properties.currency,
      transaction_id: properties.checkout_id,
    })
  }

  public trackPathClientFlowCompleted() {
    this.track('5g_kCI7J96cBEOKnvosD')
  }

  public trackProductAdded() {
    this.track('D8aUCPyc85oBEOKnvosD')
  }

  public trackProductViewed() {
    this.track('6ZTmCK-F35oBEOKnvosD')
  }

  public trackUserRegistered() {
    this.track('lR1lCJP1-6cBEOKnvosD')
  }
}
